
import React, { Component } from 'react'

import Dialog from 'material-ui/Dialog'
import FontIcon from 'material-ui/FontIcon';

import './GoPremium.css'

class GoPremium extends Component {
    render() {
        return (
            <Dialog
                title=""
                modal={false}
                open={this.props.open}
                onRequestClose={this.props.onRequestClose}
            >
                <div className="go-premium">
                    <a className="dialog-close" onClick={this.props.onRequestClose}>
                        X
                    </a>
                    <div className="go-premium-title">
                        <span className="go-premium-call-to-action">Hazte premium</span>
                        <h1 className="product-title">tempo</h1>
                    </div>
                    <div className="row">
                        {this.props.description}
                        <div className="col-xs-12 col-md-6">
                            <div className="product-version">
                                Gratis
                            </div>
                            <div className="product-detail">
                                <ul>
                                    <li>Cualquier genero </li>
                                    <li>Rockola a través de ponmusica.com</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className="product-version">
                                Premium
                            </div>
                            <div className="product-detail">
                                <ul>
                                    <li>Cualquier género </li>
                                    <li>Horarios de activación </li>
                                    <li>Logo personalizado </li>
                                    <li>Código de votación personalizado </li>
                                    <li>Aplicación de escritorio </li>
                                    <li>Publicidad personalizada </li>
                                    <li>Libre de anuncios </li>
                                    <li>Restricciones personalizadas </li>
                                    <li>Offline </li>
                                    <li>Transmisiones en vivo de Youtube </li>
                                    <li>Adstter Control Center APP </li>
                                </ul>

                            </div>
                            <div class="go-premium-contact-container">
                                <a className="go-premium-contact" href="https://ponmusica.com/contact">
                                    Contactar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default GoPremium;



// WEBPACK FOOTER //
// ./src/components/go-premium/GoPremium.js